import { lazy } from "react";

export { JOB_OFFERS_PATH } from "./path";
export const JobOffersPage = lazy(() => import("./page"));
